import DEFAULTS from '../constants/default-state-values';
import { getConnectionScenario } from '../services/state-marshaller-utils';
import { NONE } from '../constants/fuel-availability-codes';
import { regionsList } from '../services/state-marshaller-utils';

export function setPlansQueryEventStatus(status, state) {
  return {
    ...state,
    plansQueryEvent: {
      ...state.plansQueryEvent,
      status,
    },
  };
}

export function setPostcodeFilter(newPostcode, state) {
  return {
    ...state,
    filters: {
      ...state.filters,
      postcode: newPostcode,
    },
  };
}

export function setPlans(plans, state) {
  return {
    ...state,
    plans,
  };
}

export function setAlternateHierarchy(alternateHierarchy, state) {
  return {
    ...state,
    alternateHierarchy,
  };
}

export function setUserAddressId(userAddressId, state) {
  return {
    ...state,
    user: {
      ...state.user,
      userAddressId,
    },
  };
}

export function setUserRegion(userRegion, state) {
  return {
    ...state,
    user: {
      ...state.user,
      userRegion,
    },
  };
}

/**
 * set QASAddress object
 */
export function setQasAddressObject(qasAddressObject, state) {
  return {
    ...state,
    qasAddressObject: qasAddressObject,
  };
}

/**
 * @param {boolean} addressUpdate
 */
export function setAddressUpdate(addressUpdate, state) {
  return {
    ...state,
    addressUpdate,
  };
}

export function setError(error, state) {
  const newErrorState = error
    ? {
        title: error.title,
        message: error.message,
        action: error.action,
      }
    : error;

  return {
    ...state,
    error: newErrorState,
  };
}

export function setFuelEligibilityStatuses({ gas, electricity }, state) {
  return {
    ...state,
    fuelEligibilityStatus: {
      // Fallback to unknown response codes
      gas: gas || NONE,
      electricity: electricity || NONE,
    },
  };
}

export function handlePlansQueryFailure(message, state) {
  return {
    ...state,
    plansQueryEvent: {
      status: 'error',
      data: message,
    },
  };
}

/**
 * @param {geoTargetResponse} userLocationObject
 * @param {Object} state
 */
export function updateUserRegionAndPostcode(userLocationObject, state) {
  let newRegion = DEFAULTS.region.shortName;
  let newPostcode = DEFAULTS.region.defaultPostcode;

  if (userLocationObject) {
    if (Array.isArray(userLocationObject.subdivisions)) {
      const matchingRegion = regionsList.find(
        (region) => region.id === userLocationObject.subdivisions[0].iso_code,
      );
      if (matchingRegion) {
        newRegion = matchingRegion.id;

        // only using the post code if the geolocation returned a valid region, otherwise the post code can be some weird value depending on the country!
        if (
          userLocationObject.postal &&
          userLocationObject.postal.code &&
          userLocationObject.postal.code !== '1001'
        ) {
          newPostcode = userLocationObject.postal.code || newPostcode;
        }
      }
    }
  }

  return {
    ...state,
    filters: {
      ...state.filters,
      postcode: newPostcode,
    },
    user: {
      ...state.user,
      userRegion: newRegion,
    },
  };
}

export function updateServicesRequired(newFilters, state) {
  return {
    ...state,
    filters: {
      ...state.filters,
      servicesRequired: {
        electricity: newFilters.requiresElectricity,
        gas: newFilters.requiresGas,
      },
    },
  };
}

export function updateFilterValues(newFilters, state) {
  return {
    ...state,
    filters: {
      ...state.filters,
      servicesRequired: {
        electricity: newFilters.requiresElectricity,
        gas: newFilters.requiresGas,
      },
      hasSolarPanels: newFilters.hasSolarPanels,
      renewableEnergy: newFilters.renewableEnergy,
      isCustomerMoving: newFilters.isCustomerMoving,
      postcode: newFilters.postcode,
      connectionScenario: getConnectionScenario(
        newFilters.isCustomerMoving,
        state.filters.isCustomer,
      ),
    },
  };
}
